<template>
  <div class="p-6 loading-table" v-if="loading">
    <spinner-color />
  </div>
  <div v-else>
    <data-table-order
      :data="this.$store.state.dataList.orders"
      :header="header"
      :body="body"
      :pageName="pageName"
      :titlePage="titlePage"
      :statusForAdvancedSearch="statusForAdvancedSearch"
      :advancedSearchData="advancedSearchData"
    />
  </div>
</template>

<script>
import DataTableOrder from "../components/table-components/DataTableOrder.vue";
import SpinnerColor from "@/views/components/table-components/SpinnerColor2.vue";
import loadingTable from "@/mixins/loadingTable.js";
import allStatus from "@/views/status/orderStatus";

export default {
  mixins: [loadingTable],
  components: {
    DataTableOrder,
    SpinnerColor,
  },
  data() {
    return {
      header: [
        { header: "sentDate", key: "sent_at" },
        { header: "dueDate", key: "execution_date" },
        { header: "code", key: "code" },
        { header: "sender", key: "second_client" },
        { header: "receiver", key: "receiver" },
        { header: "government", key: "gov_name" },
        { header: "area", key: "area" },
        { header: "amountCollect", key: "amount" },
        { header: "amountSupplied", key: "cash_amount" },
        { header: "branch", key: "branch_name" },
        { header: "captain", key: "captain_name" },
      ],
      body: [
        "sent_at",
        "execution_date",
        "code",
        "second_client",
        "receiver",
        "gov_name",
        "area",
        "amount",
        "cash_amount",
        "branch_name",
        "captain_name",
      ],
      advancedSearchData: [
        {
          label: "sentDate",
          nameToEndpoint: "sentDate",
          max: "",
          type: "date",
        },
        { label: "dueDate", nameToEndpoint: "dueDate", max: "", type: "date" },
        { label: "code", nameToEndpoint: "code", max: "", type: "text" },
        { label: "sender", nameToEndpoint: "sender", max: 15, type: "text" },
        {
          label: "receiver",
          nameToEndpoint: "receiver",
          max: 15,
          type: "text",
        },
        { label: "area", nameToEndpoint: "area", max: 13, type: "text" },
        {
          label: "amountCollect",
          nameToEndpoint: "amountCollect",
          max: 15,
          type: "text",
        },
        {
          label: "amountSupplied",
          nameToEndpoint: "amountSupplied",
          max: 15,
          type: "text",
        },
      ],
      statusForAdvancedSearch: allStatus.wallet,
      pageName: "order/supplied",
      titlePage: "supplied",
    };
  },
  async created() {
    this.credentials.page = "order/supplied";
    this.fetchData(this.credentials);
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/vuexy/_loadingTable.scss";
</style>
